export default [
  {
    alias: 'text',
    name: 'Text',
  },
  {
    alias: 'number',
    name: 'Number',
  },
  {
    alias: 'boolean',
    name: 'Yes or No',
  },
  {
    alias: 'date',
    name: 'Date',
  },
  {
    alias: 'list',
    name: 'List',
  },
  {
    alias: 'email',
    name: 'Email',
  },
];
